import React, { useState, useContext, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CircularProgress from '@material-ui/core/CircularProgress'

import { searchPartNumberRulesAPI } from 'services/helpers/apis/partNumberRules'
import { GlobalContext } from 'routes'

const WAIT_INTERVAL = 1000
let timer

const AutocompleteSearch = ({
  supplierIds,
  partNumberClassIds,
  onChangeTerm,
}) => {
  const context = useContext(GlobalContext)
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    timer = null
  }, [])

  const onChangeSearchField = async (e) => {
    clearTimeout(timer)
    setSearchValue(e.target.value)
    const termValue = e.target.value

    const strSupplierIds = supplierIds.toString()
    const strPartNumberClassIds = partNumberClassIds.toString()

    timer = setTimeout(async () => {
      setLoading(true)
      try {
        const res = await searchPartNumberRulesAPI(
          termValue,
          strSupplierIds,
          strPartNumberClassIds
        )

        const terms = res.data.data.search.terms.map((term) => `${term}`)
        setOptions(terms)
      } catch (e) {
        context.onApiError(e)
      } finally {
        setLoading(false)
      }
    }, WAIT_INTERVAL)
  }

  const onChangeValue = (event, value) => {
    onChangeTerm(value)
  }

  return (
    <Autocomplete
      id='asynchronous-demo'
      style={{ width: 200 }}
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      getOptionSelected={(option, value) => option === value}
      options={options}
      loading={loading}
      onChange={onChangeValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Search'
          variant='outlined'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          value={searchValue}
          onChange={onChangeSearchField}
        />
      )}
    />
  )
}

export default AutocompleteSearch
